import { makeAutoObservable } from "mobx";

export class ChatStore {
  private _isWebSearchActive: boolean = false;
  private _selectedFiles: File[] = [];

  constructor() {
    makeAutoObservable(this);
  }

  setIsWebSearchActive(value: boolean) {
    this._isWebSearchActive = value;
  }

  get isWebSearchActive(): boolean {
    return this._isWebSearchActive;
  }

  get selectedFiles(): File[] {
    return this._selectedFiles;
  }

  tryAddSelectedFiles(files: File[], maxSize: number) {
    const snapshot = [...this._selectedFiles];

    const merged = [...this._selectedFiles, ...files];

    const totalSize = merged.reduce((acc, file) => acc + file.size, 0);

    if (totalSize > maxSize) {
      this._selectedFiles = snapshot;
      return false;
    }

    this._selectedFiles = merged;

    return true;
  }

  removeSelectedFile(index: number) {
    this._selectedFiles = this._selectedFiles.filter((_, i) => i !== index);
  }

  clearSelectedFiles() {
    this._selectedFiles = [];
  }
}
